import { Context } from "@nuxt/types";

import { type ManyGiftGuidesResponse } from "@/store/gift-guides/types";
import Api from "@/utils/api";

const DEFAULT_ITEM_LIMIT = 36;

export default class GiftGuidesApi extends Api {
  readonly url = "/v3/activities/";

  constructor($axios: Context["$axios"]) {
    super("giftGuideService", $axios);
  }

  async getGiftGuidesByRecipient({
    audience,
    limit = DEFAULT_ITEM_LIMIT,
    next,
  }: {
    audience: string;
    limit?: number;
    next?: string;
  }) {
    return await this.request<ManyGiftGuidesResponse>({
      method: "GET",
      url: `${this.url}giftguides`,
      params: {
        audience,
        limit,
        next,
        includes: ["shop_product_collections", "profiles"],
      },
    });
  }
}
